import register from '../register';
import debounce from './util/debounce';

register( 'site-footer', () => {

  let spacer = document.querySelector('.site-footer__spacer');
  let footer = document.querySelector('.site-footer');

  function setHeight() {
    let footerHeight = footer.offsetHeight;
    spacer.style.height = footerHeight + 'px';
  }

  window.addEventListener( 'load', setHeight );
  window.addEventListener( 'resize', debounce( setHeight, 200 ) );

});

export default undefined;
